export function getVuzSignature() {
    let fileSignatures = [];
    const $inputWithSigData = $_pro('#vuz_file_signatures');
    if ($inputWithSigData.length === 1 && $inputWithSigData.data('vuz_file_signatures') !== undefined) {
        fileSignatures = $inputWithSigData.data('vuz_file_signatures');
    }
    return fileSignatures;
}

export function sigTooltipHandler() {
    const viewSignatureDate = $_pro(this).data('view_signature_date') || '';
    const signatureId = $_pro(this).data('signature-id') || 0;
    let title = '';
    const signatures = getVuzSignature();

    if (signatureId > 0 && signatureId in signatures) {
        const signature = signatures[signatureId];
        title = `Дата и время подписания: ${viewSignatureDate}<br>ФИО подписавшего документ: ${signature.full_name}
                     <br>Должность: ${signature.post}<br>Уникальный программный ключ:<br>${signature.key}`;
    }
    return title;
}